import { saveAs } from "file-saver";
import { ChangeTypes, EncodedDataClient, IEncodedDataClient } from "app/SharedApiClient";
import { BASE_SHARED_API_URL } from "const/baseUrl";

const encodedDataSharedClient: IEncodedDataClient = new EncodedDataClient(BASE_SHARED_API_URL);

type EntityType = "Root" | "Modified" | "Stack";

export const getProjectFileName = (
  projectId: string,
  projectName: string,
  versionId: string,
  entityType: EntityType,
  extension: string,
  extraSuffix?: string,
) => {
  const fileName = `${
    extraSuffix ? extraSuffix + "-" : ""
        }${projectId}-${projectName}-${versionId}-${entityType}_DM${extension}`;
  return fileName;
};

export const downloadEncodingVersionChanges = async ({
  currentVersionId,
  projectId,
  projectName,
  changesType,
  source,
}: {
  projectId: string;
  projectName: string;
  currentVersionId: string;
  changesType: ChangeTypes;
  source: string;
}) => {
  const fileName = getProjectFileName(projectId, projectName, currentVersionId, "Root", ".csv");
  const response = await encodedDataSharedClient.downloadEncodingVersionChangesFile(
    projectId,
    currentVersionId,
    changesType,
    source,
  );
  saveAs(response.data, fileName);
};

export const downloadFile = (url: string | undefined) => {
  if (url) {
    window.open(url, "_blank");
  }
};
